(function () {
  'use strict';

  /* Bail if the user has requested reduced motion */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ---------------------------------------------------------------
     Single shared IntersectionObserver.
     Each element is unobserved after its first reveal — no ongoing
     scroll work after the page is fully visible.
  --------------------------------------------------------------- */
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('dn-visible');
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: '0px 0px -56px 0px', threshold: 0.08 }
  );

  /* ---------------------------------------------------------------
     wire(selector, animClass, stagger)
     - Adds the CSS animation class to every matching element
     - Sets --dn-i for stagger delay when stagger = true
     - Registers each element with the observer
  --------------------------------------------------------------- */
  function wire(selector, animClass, stagger) {
    document.querySelectorAll(selector).forEach(function (el, i) {
      el.classList.add(animClass);
      if (stagger) el.style.setProperty('--dn-i', i);
      io.observe(el);
    });
  }

  /* ---------------------------------------------------------------
     Section wire-ups
     Uses only the existing DOM class names — no liquid edits needed.
  --------------------------------------------------------------- */

  /* Features */
  wire('.dnature-features__headline', 'dn-up');
  wire('.dnature-features__card',     'dn-up',   true);
  wire('.dnature-features__badge',    'dn-fade',  true);

  /* Favorites carousel */
  wire('.dnature-favorites__subtitle', 'dn-up');
  wire('.dnature-favorites__title',    'dn-up');

  /* Ingredients */
  wire('.dnature-ingredients__header', 'dn-up');
  wire('.dnature-ingredients__card',   'dn-scale', true);

  /* About — opposite-direction split */
  wire('.dnature-about__image-wrapper', 'dn-from-left');
  wire('.dnature-about__content',       'dn-from-right');

  /* Press */
  wire('.dnature-press__title',     'dn-up');
  wire('.dnature-press__logo-item', 'dn-fade', true);

  /* Values */
  wire('.dnature-values__headline', 'dn-up');
  wire('.dnature-values__item',     'dn-up', true);

  /* FAQ */
  wire('.dnature-faq__subtitle',      'dn-up');
  wire('.dnature-faq__title',         'dn-up');
  wire('.dnature-faq__image-wrapper', 'dn-from-right');
  wire('.dnature-faq__item',          'dn-up', true);

  /* Testimonials */
  wire('.dnature-testimonials__subtitle', 'dn-up');
  wire('.dnature-testimonials__title',    'dn-up');
  wire('.dnature-testimonials__card',     'dn-scale', true);

  /* Blog */
  wire('.dnature-blog__subtitle', 'dn-up');
  wire('.dnature-blog__title',    'dn-up');
  wire('.dnature-blog__card',     'dn-up', true);

}());
